import React, { Component, PropTypes } from 'react';
import {
  sendInvitation,
  resendInvitation,
  acceptConnection,
  ignoreConnection,
  fakeResendInvitation,
  openPopover,
  closePopover,
  updateCustomizedMsg,
} from '../../../stores/partner-finder/partnerFinder-actions';
import { RaisedButton, FlatButton } from 'material-ui';
import Icon from '../../tc-ui/icon';
import SendCustomMsg from '../../partner-finder/send-custom-msg';
import { connect } from 'react-redux';
import { equals } from 'ramda';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import languagesObj from '../../../localization/languages.json';
import WallWrapper from '../../wall/wrapper';
const languageSettings = languagesObj['en-US'];

class CompanyConnection extends Component {
  acceptConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    const { companyId, locationId, productId } = this.props.profileToShow;
    dispatch(acceptConnection(connectionId, companyId, locationId, productId))
      .then(() => {
        triggerSnackBarMessage({ message: 'Invitation Accepted' });
      })
      .catch(() => {
        triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
        // dispatch(undoConnectionChange());
      });
  };

  _fakeResendInvitation = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    const { companyId, locationId, productId } = this.props.profileToShow;
    dispatch(fakeResendInvitation(connectionId, companyId, locationId, productId))
      .then(() => {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      })
      .catch(() => {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      });
  };

  ignoreConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    const { companyId, locationId, productId } = this.props.profileToShow;
    dispatch(ignoreConnection(connectionId, companyId, locationId, productId))
      .then(() => {
        triggerSnackBarMessage({ message: 'Connection Request Ignored' });
      })
      .catch(() => {
        triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
      });
  };

  resendConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    const { companyId, locationId, productId } = this.props.profileToShow;
    dispatch(resendInvitation(connectionId, companyId, locationId, productId))
      .then(() => {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      })
      .catch(() => {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
        // dispatch(undoConnectionChange());
      });
  };

  initConnect = customMsg => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    const { companyId, locationId, productId } = this.props.profileToShow;
    dispatch(sendInvitation(customMsg, { companyId, locationId, productId }))
      .then(() => {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      })
      .catch(() => {
        triggerSnackBarMessage({ message: 'Sending Invitation Failed' });
      });
  };

  render() {
    let raisedButton;
    const { basicUser, isViewingOwnProfile } = this.props;
    const { connectionInfo } = this.props.profileToShow;
    const { companyId, locationId, productId, companyName, viewingAs } = this.props.profileToShow;
    const acceptedButton = (
      <div className="company-connected-status">
        <CheckIcon
          color={'rgba(0, 0, 0, 0.54)'}
          style={{ marginRight: '3px', top: '5px', position: 'relative' }}
        />
        <span>Partners</span>
      </div>
    );
    if (isViewingOwnProfile) {
      raisedButton = equals(viewingAs, 'connected') ? (
        acceptedButton
      ) : (
        <RaisedButton primary fullWidth label={languageSettings.company.leftNav.unconnected} />
      );
    } else {
      switch (connectionInfo.status) {
        case 'accepted':
          raisedButton = acceptedButton;
          break;
        case 'pending':
          if (connectionInfo.isSender) {
            raisedButton = (
              <div>
                <RaisedButton
                  secondary
                  fullWidth
                  label="RESEND PARTNER REQUEST"
                  onClick={this.resendConnection.bind(this, connectionInfo.id)}
                />
                <br />
                <span className="last-sent" style={{ lineHeight: '8px' }}>
                  Last sent {connectionInfo.lastSent}
                </span>
              </div>
            );
          } else {
            raisedButton = (
              <div className="company-connected-status">
                <span className="company-connection-text">
                  {languageSettings.company.leftNav.accept}
                </span>
                <div className="company-connection-buttons">
                  <Icon
                    className="tc-icon-close"
                    onClick={this.ignoreConnection.bind(this, connectionInfo.id)}
                  />
                  <Icon
                    className="tc-icon-check"
                    onClick={this.acceptConnection.bind(this, connectionInfo.id)}
                  />
                </div>
              </div>
            );
          }
          break;
        case 'unconnected':
          // TO DO
          raisedButton = (
            <RaisedButton
              fullWidth
              secondary
              style={{ marginLeft: basicUser ? '5%' : '0' }}
              label="SEND PARTNER REQUEST"
              onClick={e =>this.props.openPopover({
                  popOverAnchorEl: e.currentTarget,
                  receiverInfo: { companyId, locationId, productId, companyName },
              })}
            >
              <SendCustomMsg
                sendInvitation={this.initConnect}
                onRequestClose={this.props.closePopover}
                updateCustomizedMsg={this.props.updateCustomizedMsg}
              />
            </RaisedButton>
          );
          break;
        case 'rejected':
          if (connectionInfo.isSender) {
            raisedButton = (
              <div>
                <RaisedButton
                  fullWidth
                  onClick={this._fakeResendInvitation.bind(this, connectionInfo.id)}
                  secondary
                  label={languageSettings.company.leftNav.resend}
                />
                <br />
                <span className="last-sent" style={{ lineHeight: '8px' }}>
                  Last sent {connectionInfo.lastSent}
                </span>
              </div>
            );
          } else {
            raisedButton = (
              <FlatButton
                fullWidth
                disabled
                label={languageSettings.partnerFinder.rightContent.ignored}
              />
            );
          }
          break;
        default:
          break;
      }
    }

    return (
      <div className="profile-connection-info">
        <span
          style={{
            whiteSpace: basicUser ? 'pre' : undefined,
            marginLeft: basicUser ? '-10px' : undefined,
          }}
        >
          {raisedButton}
        </span>
      </div>
    );
  }
}
const mapStateToProps = ({ partnerFinder, user }) => ({
  sendCustomMsg: partnerFinder.get('sendCustomMsg').toJS(),
  userId: user.getIn(['user', 'userID']),
  basicUser: (user.get('billingPlan') || 'basic') === 'basic',
});

import { openUpgradeFrom } from '../../../stores/ui/components/upgrade/upgrade-actions';
const mapDispatchToProps = dispatch => ({
  closePopover: () => dispatch(closePopover()),
  openPopover: payload => dispatch(openPopover(payload)),
  updateCustomizedMsg: payload => dispatch(updateCustomizedMsg(payload)),
  openUpgrade: clickedCompany => dispatch(openUpgradeFrom('profileConnectBtn', { clickedCompany })),
});

CompanyConnection.propTypes = {
  dispatch: PropTypes.func,
  triggerSnackBarMessage: PropTypes.func,
  profileToShow: PropTypes.object,
  partnerFinder: PropTypes.object,
  basicUser: PropTypes.bool,
  history: PropTypes.object,
  openPopover: PropTypes.func,
  closePopover: PropTypes.func,
  updateCustomizedMsg: PropTypes.func,
  isViewingOwnProfile: PropTypes.bool,
  openUpgrade: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyConnection);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/company-connection.jsx